import React from 'react';
import { arrayOf, number, shape, string } from 'prop-types';
import DynamicIcon from 'components/DynamicIcon';

Facility.propTypes = {
  href: string,
  rotate: number,
  arrayEle: arrayOf(number),
  vertices: arrayOf(shape({
    id: number,
    cx: number,
    cy: number
  }))
};

function Facility(props) {
  const { href, rotate, arrayEle, vertices } = props;

  return (
    <>
      {arrayEle?.length && (
        arrayEle?.map(targetId => {
          const item = vertices.find(element => (element.id === targetId));
          if (item) {
            return (
              <DynamicIcon
                key={item.id}
                rotate={rotate}
                href={href}
                x={item?.cx}
                y={item?.cy}
              />
            );
          }
          return null;
        })
      )}
    </>
  );
};

Facility.defaultProps = {
  vertices: []
}

export default Facility;